"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.DialogLoadingOverlay = void 0;
var _mui = require("@ori-ui/mui");
var _testidGenerator = _interopRequireDefault(require("@ori/testid-generator"));
var _react = require("react");
var _sharedStyles = require("./sharedStyles");
var _jsxRuntime = require("react/jsx-runtime");
/* eslint-disable @typescript-eslint/naming-convention -- prop name format given by external lib */

const Root = (0, _mui.styled)('div')(({
  ownerState: {
    isFullScreen
  }
}) => ({
  ..._sharedStyles.sharedLoadingStyles,
  ...(isFullScreen && {
    left: 0,
    position: 'fixed',
    top: 0,
    width: '100%'
  })
}));
const DialogLoadingOverlay = exports.DialogLoadingOverlay = /*#__PURE__*/(0, _react.memo)(({
  id,
  isFullScreen = false
}) => {
  const {
    getTestId
  } = (0, _testidGenerator.default)();
  const testId = getTestId(id);
  const props = {
    color: 'primary',
    'data-testid': testId
  };
  const ownerState = {
    isFullScreen
  };
  return /*#__PURE__*/(0, _jsxRuntime.jsx)(Root, {
    ownerState: ownerState,
    children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_mui.CircularProgress, {
      ...props
    })
  });
});